// ----------------------------------------------------------------------------
// Component: Site Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------
import $ from 'jquery';


var headerClass  = '.header';
var menuClass    = '.menu--default';
var menuToggle   = '.header__link--menu';


function openMenu(menu, focusItem) {
    closeAllMenus(menu.$dropdown);
    // open menu
    menu.$dropdown.addClass('js--isOpen');
    menu.$dropdown.children('.menu__link').attr('aria-expanded', 'true');

    // move focus
    setTimeout(function(event){
        focusItem.get(0).focus();
        // focusItem.attr('tabindex', '0');
    }, 150);
}

function closeMenu(submenu) {
    // close menu
    submenu.$parentDropdown.removeClass('js--isOpen');
    submenu.$parentDropdown.children('.menu__link').attr('aria-expanded', 'false');

}

function closeAllMenus(menuDropdown) {
    menuDropdown.removeClass('js--isOpen');
    menuDropdown.siblings().removeClass('js--isOpen');
    menuDropdown.children('.menu__link').attr('aria-expanded', 'false');
    menuDropdown.siblings().children('.menu__link').attr('aria-expanded', 'false');
}

function moveFocusTo(focusItem) {
    focusItem.get(0).focus();
}

function moveTabindex(menuDropdown, menuLink) {
    menuDropdown.parents('.menu__list').find('.menu__link').attr('tabindex', '-1');
    menuLink.attr('tabindex', '0');
}

function hoverMenu() {
    if ($(window).width() >= 1025) {
        $('.menu__item--dropdown:not(.js--bound)').addClass('js--bound').on('mouseenter mouseleave', allowHoverOnMenu)
    } else {
        $('.menu__item--dropdown.js--bound').removeClass('js--bound').off('mouseenter mouseleave', allowHoverOnMenu)
    }
}

function allowHoverOnMenu(e) {
    e.preventDefault();
    if (e.type === 'mouseenter') {
        setTimeout(function(event){
            $(e.currentTarget).addClass('js--isOpen');
            $(e.currentTarget).children('.menu__link').attr('aria-expanded', 'true');
        }, 150);

    }
    if (e.type === 'mouseleave') {
        setTimeout(function(event){
            $(e.currentTarget).removeClass('js--isOpen');
            $(e.currentTarget).children('.menu__link').attr('aria-expanded', 'false');
        }, 150);
    }
}


// Unless we click inside the header,
// we probably don't want to have open navs
$('body').on('click', function(event) {
    if (!$(event.target).closest(menuClass).length && !$(event.target).closest('.header__container').length) {
        $(menuToggle).removeClass('js--isOpen');
        $(headerClass).removeClass('js--isOpen');
        $(menuClass).removeClass('js--isOpen');
    }
});

// Open menu on mobile
$(menuToggle).on('click', function(event) {
    event.preventDefault();

    $(this).toggleClass('js--isOpen');
    $(headerClass).toggleClass('js--isOpen');
    $(menuClass).toggleClass('js--isOpen');
});

function menuDropdownMobile () {
    if($(window).width() < 1025) {
        $('.menu__item--dropdown').on('click', function(event) {
            var $dropdown = $(this).closest('.menu__item--dropdown');
    
            if ($dropdown.siblings().hasClass('js--isOpen')) {
                $dropdown.siblings().removeClass('js--isOpen');
                $dropdown.addClass('js--isOpen');
            } else {
                $dropdown.toggleClass('js--isOpen');
            }
        });
    }
}

$(document).ready(function(){

    $(window).on('load', menuDropdownMobile);

    // timeOutFunctionId stores a numeric ID which is 
    // used by clearTimeOut to reset timer
    var timeOutFunctionId;
    window.addEventListener("resize", function() {
        // clearTimeOut() resets the setTimeOut() timer
        clearTimeout(timeOutFunctionId);
         // setTimeout returns the numeric ID which is used by
        // clearTimeOut to reset the timer
        timeOutFunctionId = setTimeout(menuDropdownMobile, 500);
    });

    hoverMenu();
    $(window).on('resize', hoverMenu);

    $('.menu--header .menu__item .menu__link').on('keydown', function(e) {
        var menu = {
            $menuLink:          $(e.target),
            $menuItem:          $(e.target).closest('.menu__item'),
            $dropdownList:      $(e.target).closest('.dropdown__list'),
            $dropdown:          $(e.target).closest('.menu__item--dropdown'),
            $dropdownLink:      $(e.target).closest('.dropdown__link'),
        };

        if (e.type === 'keydown') {
            let key = e.key;
            if (key === "Tab") {
               closeAllMenus(menu.$dropdown);
            } else {
                // If not Tab
                let menuItem,
                menuItemLink,
                focusLink;

                switch(key) {
                    case 'Enter': // Enter
                        // Opens submenu and moves focus to first item in submenu
                        focusLink = menu.$dropdown.find('.dropdown__link').first();
                        openMenu(menu, focusLink);
                        break;
                    case ' ': // Space
                        // Opens submenu and moves focus to first item in submenu
                        e.preventDefault();
                        focusLink = menu.$dropdown.find('.dropdown__link').first();
                        openMenu(menu, focusLink);
                        break;
                    
                    case 'Home': // Home
                        //  Moves focus to first item in the menubar.
                        e.preventDefault();
                        menuItem = menuItem = menu.$menuLink.parent().siblings().first();
                        menuItemLink = menuItem.children('.menu__link');
                        moveFocusTo(menuItemLink);
                        moveTabindex(menu.$menuItem, menuItemLink);
                        break;
                    case 'End': // End
                        // Moves focus to last item in the menubar.
                        e.preventDefault();
                        menuItem = menuItem = menu.$menuLink.parent().siblings().last();
                        menuItemLink = menuItem.children('.menu__link');
                        moveFocusTo(menuItemLink);
                        moveTabindex(menu.$menuItem, menuItemLink);
                        break;
                    default: // Any other character?
                        // Moves focus to next item in the menubar having a name that starts with the typed character. If none of the items have a name starting with the typed character, focus does not move.
                        menu.$menuItem.siblings().each(function(index, menuItem) {
                            let menuLink = $(menuItem).children('.menu__link');
                            let firstChar = menuLink[0].innerText.charAt(0).toLowerCase();
                            if (key.toLowerCase() === firstChar) {
                                moveFocusTo(menuLink);
                                moveTabindex($(menuItem), menuLink);
                                return false;
                            }
                        })
                }
            }
        }
    });

    $('.dropdown__item .dropdown__link').on('keydown', function(e) {
        var submenu = {
            $menuLink:          $(e.target),
            $dropdown:          $(e.target).parent(),
            $parentDropdown:    $(e.target).parents('.menu__item'),
            $parentLink:        $(e.target).parents('.menu__item').children('.menu__link'),
            $megaMenuColumn:    $(e.target).parents('.mega-nav__col')
            
        };

        let key = e.key;
        if (key === "Tab") {
            
            if (!e.shiftKey) {
                //Close submenu if "Tab" reaches last menuLink Element in the Last MegaMenu Column
                if ((submenu.$dropdown.is(':last-child') && submenu.$megaMenuColumn.is(':last-child')) || (submenu.$dropdown.is(':last-child') && submenu.$megaMenuColumn.length < 1))  {
                    closeAllMenus(submenu.$parentDropdown);
                } 
                
                //Close submenu if "Tab" reaches the last button menuLink Element
                if (submenu.$menuLink.is('.mega-nav__button-link:last-child')) {
                    closeAllMenus(submenu.$parentDropdown);
                }
            }
            
        } else {
            // If not Tab
            let menuItem,
            menuItemLink,
            mega_dropdown,
            focusLink;

            switch(key) {
                case 'Enter': // Enter
                    // Activates menu item, causing the link to be activated.
                    break;
                case ' ': // Space
                    // Activates menu item, causing the link to be activated.
                    e.preventDefault();
                    submenu.$menuLink[0].click();
                    break;
                case 'Escape':
                    // Closes submenu. Moves focus to parent menubar item.
                    closeMenu(submenu);
                    moveFocusTo(submenu.$parentLink);
                    break;
                
                case 'Home': // Home
                    //  Moves focus to the first item in the submenu.
                    e.preventDefault();
                    menuItem = submenu.$dropdown.siblings().first();
                    menuItemLink = menuItem.children('.dropdown__link');
                    moveFocusTo(menuItemLink);
                    break;
                case 'End': // End
                    // Moves focus to the last item in the submenu.
                    e.preventDefault();
                    menuItem = submenu.$dropdown.siblings().last();
                    menuItemLink = menuItem.children('.dropdown__link');
                    moveFocusTo(menuItemLink);
                    break;
                default: // Any other character?
                    e.preventDefault();
                    // Moves focus to next item in the submenu having a name that starts with the typed character. If none of the items have a name starting with the typed character, focus does not move.
                    submenu.$dropdown.siblings().each(function(index, menuItem) {
                        let menuLink = $(menuItem).children('.dropdown__link');
                        let firstChar = menuLink[0].innerText.charAt(0).toLowerCase();
                        if (key.toLowerCase() === firstChar) {
                            moveFocusTo(menuLink);
                            moveTabindex($(menuItem), menuLink);
                            return false;
                        }
                    })
            }
        }

    });

    $('.menu__item--dropdown .menu__link').on('click', function(event) {
        //event.preventDefault();
    });
});

// Country Switcher
var COUNTRY_TOGGLE = '.country-switch__toggle';
var COUNTRY_LIST   = '.country-switch__list';

$(document).ready(function(){

    // If you click anywhere outside of the search, close it
    $('body').on('click', function(event) {
        if (!$(event.target).closest(COUNTRY_TOGGLE).length) {
            $(COUNTRY_TOGGLE).removeClass('is-open');
            $(COUNTRY_LIST).removeClass('is-open');
        }
    });

    // When you click the search icon, toggle the open state
    $(COUNTRY_TOGGLE).on('click', function(event) {
        // don't fire if we are opening the switcher by clicking on the active link.
        event.preventDefault();
        $(this).toggleClass('is-open');
        $(this).siblings(COUNTRY_LIST).toggleClass('is-open');
    });
});

// If you click anywhere outside of the search, close it
// $('body').on('click', function(event) {
//     if (!$(event.target).closest(COUNTRY_LIST).length) {
//         $(COUNTRY_LIST).removeClass('is-open');
//     }
// });

// // When you click the search icon, toggle the open state
// $(COUNTRY_LIST).find('.is-current a').on('click', function(event) {

//     // don't fire if we are opening the switcher by clicking on the active link.
//     event.preventDefault();
//     $(this).parents(COUNTRY_LIST).toggleClass('is-open');

// });

// Header Sticky State
$(window).scroll(function(){
    if($(window).scrollTop() > 0) {
        $('.header').addClass('is-sticky');
        $('.announcement-bar').addClass('is-sticky');
    }else {
        $('.header').removeClass('is-sticky');
        $('.announcement-bar').removeClass('is-sticky');
    }
});

